import { Button } from 'gf-ui-components-mui-lib';

const ArrowBtn = ({ disabled, onClick, children, height, width, id = '' }: any) => {
  return (
    <Button
      {...{
        id,
        sx: {
          display: 'flex',
          padding: '16px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'var(--btn-01-primary-enabled, #2469F3)',
          height: height ? height : '56px',
          width: width ? width : '56px',
          minWidth: '0px',
          borderRadius: '4px',
          color: '#fff',
          ':hover': {
            background: 'var(--btn-01-primary-enabled, #2469F3)',
            boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10), 0px -4px 8px 0px rgba(0, 0, 0, 0.05)'
          },
          '&.MuiButton-root.Mui-disabled ': {
            background: 'rgba(36, 105, 243, 0.30) !important',
            color: '#fff'
          }
        },
        onClick: onClick,
        disabled: disabled
      }}
      children={children}
    />
  );
};

export default ArrowBtn;
